import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { ProgressBarWizardEvents } from '../../components/common/progressbarwizard/progressbar.wizard.events';
import { ArrayHelpers } from '../../helpers/array.helpers';
import { SmartSyncService } from '../../services/smart.sync.service';
import { SmartIntegrationWizardFilterPage } from './smartintegrationwizard/siw.filter.page';
import { SmartIntegrationWizardFinishPage } from './smartintegrationwizard/siw.finish.page';
import { SmartIntegrationWizardSourcePage } from './smartintegrationwizard/siw.source.page';
import { SmartIntegrationWizardSourceTablePage } from './smartintegrationwizard/siw.source.table.page';
import { SmartIntegrationWizardTargetPage } from './smartintegrationwizard/siw.target.page';
import { SmartIntegrationWizardUseCasePage } from './smartintegrationwizard/siw.use.case.page';

@Component({
    selector: 'smart-integration-control',
    templateUrl: './smart.integration.control.html',
    styleUrls: ['./smart.integration.control.css']
})
export class SmartIntegrationControl implements OnInit, OnDestroy {

    WizardPages: any[] = [
        { Caption: "@@SIW-DataSource", Content: SmartIntegrationWizardSourcePage, disabled: false },
        { Caption: "@@SIW-UseCase", Content: SmartIntegrationWizardUseCasePage, disabled: true },
        { Caption: "@@SIW-ChooseTables", Content: SmartIntegrationWizardSourceTablePage, disabled: true },
        { Caption: "@@SIW-Filter", Content: SmartIntegrationWizardFilterPage, disabled: true },
        { Caption: "@@SIW-ChooseTarget", Content: SmartIntegrationWizardTargetPage, disabled: true },
        { Caption: "@@SIW-Finish", Content: SmartIntegrationWizardFinishPage, disabled: true }
    ];
    Loading = true;
    ShowWizard = false;
    LoadedCases = [];
    FilteredCases = [];
    SearchText: string;
    SortColumn: number;
    SortList = [];
    Columns = [];
    Subscription: Subscription;

    static GetMenuEntry() {
        return {
            Caption: '@@SI_Navigation',
            ID: 'smartIntegrationControl',
            Icon: 'smart_integration',
            Index: 20,
            URL: '/integration/smartsync'
        };
    }

    constructor(private cdRef: ChangeDetectorRef, private service: SmartSyncService, translate: TranslateService) {
        this.Columns = [
            {
                Caption: translate.instant('@@Name'),
                Value: 'Name',
                Type: 0
            },
            {
                Caption: translate.instant('@@Quelle'),
                Value: 'Source',
                Type: 0
            },
            {
                Caption: translate.instant('@@Ziel'),
                Value: 'Target',
                Type: 0
            },
            {
                Caption: translate.instant('@@GA-SIW-LastRun'),
                Value: 'LastRunText',
                Type: 0
            },
            {
                Caption: translate.instant('@@Status'),
                Type: 1
            },
            //{
            //    Caption: translate.instant('@@Aktionen'),
            //    Type: 2
            //}
        ];
        this.SortList = [
            {
                Caption: translate.instant('@@GA-SIW-SortNameAsc'),
                Value: 0
            },
            {
                Caption: translate.instant('@@GA-SIW-SortNameDesc'),
                Value: 1
            },
            {
                Caption: translate.instant('@@GA-SIW-SortRunDesc'),
                Value: 2
            },
            {
                Caption: translate.instant('@@GA-SIW-SortRunAsc'),
                Value: 3
            },
            {
                Caption: translate.instant('@@GA-SIW-SortStateSuccess'),
                Value: 4
            },
            {
                Caption: translate.instant('@@GA-SIW-SortStateFailure'),
                Value: 5
            }
        ];
    }

    ngOnDestroy(): void {
        if (this.Subscription) {
            this.Subscription.unsubscribe();
            this.Subscription = null;
        }
    }

    ngOnInit(): void {
        this.Subscription = ProgressBarWizardEvents.CloseWizard.subscribe(() => {
            this.ShowWizard = false;
            this.refresh();
        });
        this.refresh();
    }

    refresh() {
        this.Loading = true;
        this.SearchText = null;
        this.SortColumn = null;
        this.LoadedCases = [];
        this.FilteredCases = [];
        this.service.GetSavedUseCases().subscribe((x: any) => {
            if (x) {
                x.forEach((y: any) => {
                    y.SearchText = y.Name.toLowerCase();
                    y.LastRunDate = new Date(y.LastRun);
                    y.LastRunText = moment(y.LastRun).format('lll');
                });
                this.LoadedCases = x;
                this.FilteredCases = [...x];
            }
            this.Loading = false;
            this.cdRef.detectChanges();
        });
        this.cdRef.detectChanges();
    }

    onSearchChanged() {
        if (this.SearchText) {
            const toLower = this.SearchText.toLowerCase();
            this.FilteredCases = this.LoadedCases.filter((x: any) => x.SearchText.includes(toLower));
        } else {
            this.FilteredCases = [...this.LoadedCases];
        }
    }

    checkSort() {
        if (this.SortColumn != null) {
            switch (this.SortColumn) {
                case 0:
                    ArrayHelpers.sortAlphabetical(this.LoadedCases, 'Name');
                    break;
                case 1:
                    ArrayHelpers.sortAlphabetical(this.LoadedCases, 'Name');
                    this.LoadedCases.reverse();
                    break;
                case 2:
                    this.LoadedCases.sort((a, b) => {
                        if (a.LastRunDate < b.LastRunDate) {
                            return 1;
                        }
                        if (a.LastRunDate > b.LastRunDate) {
                            return -1;
                        }
                        return 0;
                    });
                    break;
                case 3:
                    this.LoadedCases.sort((a, b) => {
                        if (a.LastRunDate < b.LastRunDate) {
                            return -1;
                        }
                        if (a.LastRunDate > b.LastRunDate) {
                            return 1;
                        }
                        return 0;
                    });
                    break;
                case 4:
                    this.LoadedCases.sort((a, b) => {
                        if (a.Success && !b.Success) {                            
                            return -1;
                        }
                        if (!a.Success > b.Success) {
                            return 1;
                        }
                        return 0;
                    });
                    break;
                case 5:
                    this.LoadedCases.sort((a, b) => {
                        if (a.Success && !b.Success) {
                            return 1;
                        }
                        if (!a.Success > b.Success) {
                            return -1;
                        }
                        return 0;
                    });
                    break;
            }
            this.onSearchChanged();
        }
    }
}
